import styled from 'styled-components';

const SelectorPanelOption = styled.div`
	display: flex;
	justify-content: space-between;
	border-top: 1.5px solid var(--borderLightColor);
	padding-top: 6px;
	padding-bottom: 6px;
	padding-inline: 10px;

	h3 {
		margin: 0;
		font-weight: 500;
    font-size: 14px;
		margin-bottom: 0.1em;
	}

	h4 {
		margin: 0;
		color: var(--primary);
		font-weight: 600;
		font-size: 14px;
		@media (max-width: 935px){
				 		&:after{
							display:none;
						}
				}
	}
	h3{
		color: var(--textHeadingColor);
	}			

	span {
		margin: 0;
		color: var(--textTitleColor);
		font-weight: 100;
		font-size: 12px;
	}
	
`;

const ColFlex = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%
`;

const RowFlex = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	// justify-content: space-between;
`;
export {
	SelectorPanelOption,
	RowFlex,
	ColFlex
};
